/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.MimeType_
///   This is an auto-generated enumeration of the SW_RealEstate.Core.MimeType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum MimeType_ {
   /// <summary>
   ///   application/octet-stream ()
   /// </summary>
   Application_OctetStream = 1,
   /// <summary>
   ///   application/envoy (evy)
   /// </summary>
   Application_Envoy_evy = 2,
   /// <summary>
   ///   application/fractals (fif)
   /// </summary>
   Application_Fractals_fif = 3,
   /// <summary>
   ///   application/futuresplash (spl)
   /// </summary>
   Application_Futuresplash_spl = 4,
   /// <summary>
   ///   application/hta (hta)
   /// </summary>
   Application_Hta_hta = 5,
   /// <summary>
   ///   application/internet-property-stream (acx)
   /// </summary>
   Application_InternetPropStrm_acx = 6,
   /// <summary>
   ///   application/mac-binhex40 (hqx)
   /// </summary>
   Application_MacBinhex40_hqx = 7,
   /// <summary>
   ///   application/ms-powerpoint (pff)
   /// </summary>
   Application_MsPowerpoint_pff = 8,
   /// <summary>
   ///   application/msword (doc)
   /// </summary>
   Application_Msword_doc = 9,
   /// <summary>
   ///   application/msword (dot)
   /// </summary>
   Application_Msword_dot = 10,
   /// <summary>
   ///   application/octet-stream (bin)
   /// </summary>
   Application_OctetStream_bin = 11,
   /// <summary>
   ///   application/octet-stream (dms)
   /// </summary>
   Application_OctetStream_dms = 12,
   /// <summary>
   ///   application/octet-stream (exe)
   /// </summary>
   Application_OctetStream_exe = 13,
   /// <summary>
   ///   application/octet-stream (lha)
   /// </summary>
   Application_OctetStream_lha = 14,
   /// <summary>
   ///   application/octet-stream (lzh)
   /// </summary>
   Application_OctetStream_lzh = 15,
   /// <summary>
   ///   application/oda (oda)
   /// </summary>
   Application_Oda_oda = 16,
   /// <summary>
   ///   application/olescript (axs)
   /// </summary>
   Application_Olescript_axs = 17,
   /// <summary>
   ///   application/pdf (pdf)
   /// </summary>
   Application_Pdf_pdf = 18,
   /// <summary>
   ///   application/pics-rules (prf)
   /// </summary>
   Application_PicsRules_prf = 19,
   /// <summary>
   ///   application/pkcs10 (p10)
   /// </summary>
   Application_Pkcs10_p10 = 20,
   /// <summary>
   ///   application/pkix-crl (crl)
   /// </summary>
   Application_PkixCrl_crl = 21,
   /// <summary>
   ///   application/postscript (ai)
   /// </summary>
   Application_Postscript_ai = 22,
   /// <summary>
   ///   application/postscript (ps)
   /// </summary>
   Application_Postscript_ps = 23,
   /// <summary>
   ///   application/rtf (rtf)
   /// </summary>
   Application_Rtf_rtf = 24,
   /// <summary>
   ///   application/set-payment-initiation (setpay)
   /// </summary>
   Application_SetPmtInit_setpay = 25,
   /// <summary>
   ///   application/set-registration-initiation (setreg)
   /// </summary>
   Application_SetRegInit_setreg = 26,
   /// <summary>
   ///   application/vnd.ms-excel (csv)
   /// </summary>
   Application_VndMsExcel_csv = 27,
   /// <summary>
   ///   application/vnd.ms-excel (xla)
   /// </summary>
   Application_VndMsExcel_xla = 28,
   /// <summary>
   ///   application/vnd.ms-excel (xlc)
   /// </summary>
   Application_VndMsExcel_xlc = 29,
   /// <summary>
   ///   application/vnd.ms-excel (xlm)
   /// </summary>
   Application_VndMsExcel_xlm = 30,
   /// <summary>
   ///   application/vnd.ms-excel (xls)
   /// </summary>
   Application_VndMsExcel_xls = 31,
   /// <summary>
   ///   application/vnd.ms-excel (xlt)
   /// </summary>
   Application_VndMsExcel_xlt = 32,
   /// <summary>
   ///   application/vnd.ms-excel (xlw)
   /// </summary>
   Application_VndMsExcel_xlw = 33,
   /// <summary>
   ///   application/vnd.ms-pkicertstore (sst)
   /// </summary>
   Application_VndMsPkiCertStor_sst = 34,
   /// <summary>
   ///   application/vnd.ms-pkiseccat (cat)
   /// </summary>
   Application_VndMsPkiSecCat_cat = 35,
   /// <summary>
   ///   application/vnd.ms-pkistl (stl)
   /// </summary>
   Application_VndMsPkiStl_stl = 36,
   /// <summary>
   ///   application/vnd.ms-powerpoint (pot)
   /// </summary>
   Application_VndMsPowerpoint_pot = 37,
   /// <summary>
   ///   application/vnd.ms-powerpoint (pps)
   /// </summary>
   Application_VndMsPowerpoint_pps = 38,
   /// <summary>
   ///   application/vnd.ms-powerpoint (ppt)
   /// </summary>
   Application_VndMsPowerpoint_ppt = 39,
   /// <summary>
   ///   application/vnd.ms-project (mpp)
   /// </summary>
   Application_VndMsProject_mpp = 40,
   /// <summary>
   ///   application/vnd.ms-works (wcm)
   /// </summary>
   Application_VndMsWorks_wcm = 41,
   /// <summary>
   ///   application/vnd.ms-works (wdb)
   /// </summary>
   Application_VndMsWorks_wdb = 42,
   /// <summary>
   ///   application/vnd.ms-works (wks)
   /// </summary>
   Application_VndMsWorks_wks = 43,
   /// <summary>
   ///   application/vnd.ms-works (wps)
   /// </summary>
   Application_VndMsWorks_wps = 44,
   /// <summary>
   ///   application/vnd.openxmlformats-officedocument.presentationml.presentation (pptx)
   /// </summary>
   Application_VndXmlOffice_pptx = 45,
   /// <summary>
   ///   application/vnd.openxmlformats-officedocument.spreadsheetml.sheet (xlsx)
   /// </summary>
   Application_VndXmlOffice_xlsx = 46,
   /// <summary>
   ///   application/vnd.openxmlformats-officedocument.spreadsheetml.templat (xltx)
   /// </summary>
   Application_VndXmlOffice_xltx = 47,
   /// <summary>
   ///   application/vnd.openxmlformats-officedocument.wordprocessingml.document (docx)
   /// </summary>
   Application_VndXmlOffice_docx = 48,
   /// <summary>
   ///   application/vnd.openxmlformats-officedocument.wordprocessingml.template (dotx)
   /// </summary>
   Application_VndXmlOffice_dotx = 49,
   /// <summary>
   ///   application/winhlp (hlp)
   /// </summary>
   Application_Winhlp_hlp = 50,
   /// <summary>
   ///   application/x-bcpio (bcpio)
   /// </summary>
   Application_XBcpio_bcpio = 51,
   /// <summary>
   ///   application/x-cdf (cdf)
   /// </summary>
   Application_XCdf_cdf = 52,
   /// <summary>
   ///   application/x-compress (z)
   /// </summary>
   Application_XCompress_z = 53,
   /// <summary>
   ///   application/x-compressed (tgz)
   /// </summary>
   Application_XCompressed_tgz = 54,
   /// <summary>
   ///   application/x-cpio (cpio)
   /// </summary>
   Application_XCpio_cpio = 55,
   /// <summary>
   ///   application/x-csh (csh)
   /// </summary>
   Application_XCsh_csh = 56,
   /// <summary>
   ///   application/x-director (dcr)
   /// </summary>
   Application_XDirector_dcr = 57,
   /// <summary>
   ///   application/x-director (dir)
   /// </summary>
   Application_XDirector_dir = 58,
   /// <summary>
   ///   application/x-director (dxr)
   /// </summary>
   Application_XDirector_dxr = 59,
   /// <summary>
   ///   application/x-dvi (dvi)
   /// </summary>
   Application_XDvi_dvi = 60,
   /// <summary>
   ///   application/x-gtar (gtar)
   /// </summary>
   Application_XGtar_gtar = 61,
   /// <summary>
   ///   application/x-gzip (gz)
   /// </summary>
   Application_XGzip_gz = 62,
   /// <summary>
   ///   application/x-hdf (hdf)
   /// </summary>
   Application_XHdf_hdf = 63,
   /// <summary>
   ///   application/x-internet-signup (ins)
   /// </summary>
   Application_XInternetSignup_ins = 64,
   /// <summary>
   ///   application/x-internet-signup (isp)
   /// </summary>
   Application_XInternetSignup_isp = 65,
   /// <summary>
   ///   application/x-iphone (iii)
   /// </summary>
   Application_XIphone_iii = 66,
   /// <summary>
   ///   application/x-javascript (js)
   /// </summary>
   Application_XJavascript_js = 67,
   /// <summary>
   ///   application/x-latex (latex)
   /// </summary>
   Application_XLatex_latex = 68,
   /// <summary>
   ///   application/x-mplayer2 (hold)
   /// </summary>
   Application_XMplayer2_hold = 69,
   /// <summary>
   ///   application/x-msaccess (mdb)
   /// </summary>
   Application_XMsaccess_mdb = 70,
   /// <summary>
   ///   application/x-mscardfile (crd)
   /// </summary>
   Application_XMscardfile_crd = 71,
   /// <summary>
   ///   application/x-msclip (clp)
   /// </summary>
   Application_XMsclip_clp = 72,
   /// <summary>
   ///   application/x-msdownload (dll)
   /// </summary>
   Application_XMsdownload_dll = 73,
   /// <summary>
   ///   application/x-msmediaview (m13)
   /// </summary>
   Application_XMsmediaview_m13 = 74,
   /// <summary>
   ///   application/x-msmediaview (m14)
   /// </summary>
   Application_XMsmediaview_m14 = 75,
   /// <summary>
   ///   application/x-msmediaview (mvb)
   /// </summary>
   Application_XMsmediaview_mvb = 76,
   /// <summary>
   ///   application/x-msmetafile (wmf)
   /// </summary>
   Application_XMsmetafile_wmf = 77,
   /// <summary>
   ///   application/x-msmoney (mny)
   /// </summary>
   Application_XMsmoney_mny = 78,
   /// <summary>
   ///   application/x-mspublisher (pub)
   /// </summary>
   Application_XMspublisher_pub = 79,
   /// <summary>
   ///   application/x-msschedule (scd)
   /// </summary>
   Application_XMsschedule_scd = 80,
   /// <summary>
   ///   application/x-msterminal (trm)
   /// </summary>
   Application_XMsterminal_trm = 81,
   /// <summary>
   ///   application/x-mswrite (wri)
   /// </summary>
   Application_XMswrite_wri = 82,
   /// <summary>
   ///   application/x-perfmon (pma)
   /// </summary>
   Application_XPerfmon_pma = 83,
   /// <summary>
   ///   application/x-perfmon (pmc)
   /// </summary>
   Application_XPerfmon_pmc = 84,
   /// <summary>
   ///   application/x-perfmon (pml)
   /// </summary>
   Application_XPerfmon_pml = 85,
   /// <summary>
   ///   application/x-perfmon (pmr)
   /// </summary>
   Application_XPerfmon_pmr = 86,
   /// <summary>
   ///   application/x-perfmon (pmw)
   /// </summary>
   Application_XPerfmon_pmw = 87,
   /// <summary>
   ///   application/x-pkcs12 (p12)
   /// </summary>
   Application_XPkcs12_p12 = 88,
   /// <summary>
   ///   application/x-pkcs12 (pfx)
   /// </summary>
   Application_XPkcs12_pfx = 89,
   /// <summary>
   ///   application/x-pkcs7-certificates (p7b)
   /// </summary>
   Application_XPkcs7Certs_p7b = 90,
   /// <summary>
   ///   application/x-pkcs7-certificates (spc)
   /// </summary>
   Application_XPkcs7Certs_spc = 91,
   /// <summary>
   ///   application/x-pkcs7-certreqresp (p7r)
   /// </summary>
   Application_XPkcs7CertReqRes_p7r = 92,
   /// <summary>
   ///   application/x-pkcs7-mime (p7c)
   /// </summary>
   Application_XPkcs7Mime_p7c = 93,
   /// <summary>
   ///   application/x-pkcs7-mime (p7m)
   /// </summary>
   Application_XPkcs7Mime_p7m = 94,
   /// <summary>
   ///   application/x-pkcs7-signature (p7s)
   /// </summary>
   Application_XPkcs7Signature_p7s = 95,
   /// <summary>
   ///   application/x-sh (sh)
   /// </summary>
   Application_XSh_sh = 96,
   /// <summary>
   ///   application/x-shar (shar)
   /// </summary>
   Application_XShar_shar = 97,
   /// <summary>
   ///   application/x-stuffit (sit)
   /// </summary>
   Application_XStuffit_sit = 98,
   /// <summary>
   ///   application/x-sv4cpio (sv4cpio)
   /// </summary>
   Application_XSv4cpio_sv4cpio = 99,
   /// <summary>
   ///   application/x-sv4crc (sv4crc)
   /// </summary>
   Application_XSv4crc_sv4crc = 100,
   /// <summary>
   ///   application/x-tar (tar)
   /// </summary>
   Application_XTar_tar = 101,
   /// <summary>
   ///   application/x-tcl (tcl)
   /// </summary>
   Application_XTcl_tcl = 102,
   /// <summary>
   ///   application/x-tex (tex)
   /// </summary>
   Application_XTex_tex = 103,
   /// <summary>
   ///   application/x-texinfo (texi)
   /// </summary>
   Application_XTexinfo_texi = 104,
   /// <summary>
   ///   application/x-texinfo (texinfo)
   /// </summary>
   Application_XTexinfo_texinfo = 105,
   /// <summary>
   ///   application/x-troff (roff)
   /// </summary>
   Application_XTroff_roff = 106,
   /// <summary>
   ///   application/x-troff (t)
   /// </summary>
   Application_XTroff_t = 107,
   /// <summary>
   ///   application/x-troff (tr)
   /// </summary>
   Application_XTroff_tr = 108,
   /// <summary>
   ///   application/x-troff-man (man)
   /// </summary>
   Application_XTroffMan_man = 109,
   /// <summary>
   ///   application/x-troff-me (me)
   /// </summary>
   Application_XTroffMe_me = 110,
   /// <summary>
   ///   application/x-troff-ms (ms)
   /// </summary>
   Application_XTroffMs_ms = 111,
   /// <summary>
   ///   application/x-ustar (ustar)
   /// </summary>
   Application_XUstar_ustar = 112,
   /// <summary>
   ///   application/x-wais-source (src)
   /// </summary>
   Application_XWaisSource_src = 113,
   /// <summary>
   ///   application/x-x509-ca-cert (cer)
   /// </summary>
   Application_XX509CaCert_cer = 114,
   /// <summary>
   ///   application/x-x509-ca-cert (crt)
   /// </summary>
   Application_XX509CaCert_crt = 115,
   /// <summary>
   ///   application/x-x509-ca-cert (der)
   /// </summary>
   Application_XX509CaCert_der = 116,
   /// <summary>
   ///   application/ynd.ms-pkipko (pko)
   /// </summary>
   Application_YndMsPkipko_pko = 117,
   /// <summary>
   ///   application/zip (zip)
   /// </summary>
   Application_Zip_zip = 118,
   /// <summary>
   ///   audio/basic (au)
   /// </summary>
   Audio_Basic_au = 119,
   /// <summary>
   ///   audio/basic (snd)
   /// </summary>
   Audio_Basic_snd = 120,
   /// <summary>
   ///   audio/mid (mid)
   /// </summary>
   Audio_Mid_mid = 121,
   /// <summary>
   ///   audio/mid (rmi)
   /// </summary>
   Audio_Mid_rmi = 122,
   /// <summary>
   ///   audio/mpeg3 (mp3)
   /// </summary>
   Audio_Mpeg3_mp3 = 123,
   /// <summary>
   ///   audio/x-aiff (aif)
   /// </summary>
   Audio_XAiff_aif = 124,
   /// <summary>
   ///   audio/x-aiff (aifc)
   /// </summary>
   Audio_XAiff_aifc = 125,
   /// <summary>
   ///   audio/x-aiff (aiff)
   /// </summary>
   Audio_XAiff_aiff = 126,
   /// <summary>
   ///   audio/x-mpegurl (m3u)
   /// </summary>
   Audio_XMpegurl_m3u = 127,
   /// <summary>
   ///   audio/x-pn-realaudio (ra)
   /// </summary>
   Audio_XPnRealaudio_ra = 128,
   /// <summary>
   ///   audio/x-pn-realaudio (ram)
   /// </summary>
   Audio_XPnRealaudio_ram = 129,
   /// <summary>
   ///   audio/x-wav (wav)
   /// </summary>
   Audio_XWav_wav = 130,
   /// <summary>
   ///   image/cis-cod (cod)
   /// </summary>
   Image_CisCod_cod = 131,
   /// <summary>
   ///   image/gif (gif)
   /// </summary>
   Image_Gif_gif = 132,
   /// <summary>
   ///   image/ief (ief)
   /// </summary>
   Image_Ief_ief = 133,
   /// <summary>
   ///   image/JPEG (jpe)
   /// </summary>
   Image_Jpeg_jpe = 134,
   /// <summary>
   ///   image/JPEG (jpeg)
   /// </summary>
   Image_Jpeg_jpeg = 135,
   /// <summary>
   ///   image/JPEG (jpg)
   /// </summary>
   Image_Jpeg_jpg = 136,
   /// <summary>
   ///   image/pipeg (jfif)
   /// </summary>
   Image_Pipeg_jfif = 137,
   /// <summary>
   ///   image/tiff (tif)
   /// </summary>
   Image_Tiff_tif = 138,
   /// <summary>
   ///   image/tiff (tiff)
   /// </summary>
   Image_Tiff_tiff = 139,
   /// <summary>
   ///   image/x-cmu-raster (ras)
   /// </summary>
   Image_XCmuRaster_ras = 140,
   /// <summary>
   ///   image/x-cmx (cmx)
   /// </summary>
   Image_XCmx_cmx = 141,
   /// <summary>
   ///   image/x-eps (eps)
   /// </summary>
   Image_XEps_eps = 142,
   /// <summary>
   ///   image/x-icon (ico)
   /// </summary>
   Image_XIcon_ico = 143,
   /// <summary>
   ///   image/x-ms-bmp (bmp)
   /// </summary>
   Image_XMsBmp_bmp = 144,
   /// <summary>
   ///   image/x-png (png)
   /// </summary>
   Image_XPng_png = 145,
   /// <summary>
   ///   image/x-portable-anymap (pnm)
   /// </summary>
   Image_XPortableAnymap_pnm = 146,
   /// <summary>
   ///   image/x-portable-bitmap (pbm)
   /// </summary>
   Image_XPortableBitmap_pbm = 147,
   /// <summary>
   ///   image/x-portable-graymap (pgm)
   /// </summary>
   Image_XPortableGraymap_pgm = 148,
   /// <summary>
   ///   image/x-portable-pixmap (ppm)
   /// </summary>
   Image_XPortablePixmap_ppm = 149,
   /// <summary>
   ///   image/x-psd (psd)
   /// </summary>
   Image_XPsd_psd = 150,
   /// <summary>
   ///   image/x-rgb (rgb)
   /// </summary>
   Image_XRgb_rgb = 151,
   /// <summary>
   ///   image/x-xbitmap (xbm)
   /// </summary>
   Image_XXbitmap_xbm = 152,
   /// <summary>
   ///   image/x-xpixmap (xpm)
   /// </summary>
   Image_XXpixmap_xpm = 153,
   /// <summary>
   ///   image/x-xwindowdump (xwd)
   /// </summary>
   Image_XXwindowdump_xwd = 154,
   /// <summary>
   ///   message/rfc822 (mht)
   /// </summary>
   Message_Rfc822_mht = 155,
   /// <summary>
   ///   message/rfc822 (mhtml)
   /// </summary>
   Message_Rfc822_mhtml = 156,
   /// <summary>
   ///   message/rfc822 (nws)
   /// </summary>
   Message_Rfc822_nws = 157,
   /// <summary>
   ///   text/css (css)
   /// </summary>
   Text_Css_css = 158,
   /// <summary>
   ///   text/h323 (h323)
   /// </summary>
   Text_H323_h323 = 159,
   /// <summary>
   ///   text/HTML (htm)
   /// </summary>
   Text_Html_htm = 160,
   /// <summary>
   ///   text/HTML (html)
   /// </summary>
   Text_Html_html = 161,
   /// <summary>
   ///   text/html (stm)
   /// </summary>
   Text_Html_stm = 162,
   /// <summary>
   ///   text/iuls (uls)
   /// </summary>
   Text_Iuls_uls = 163,
   /// <summary>
   ///   text/plain (bas)
   /// </summary>
   Text_Plain_bas = 164,
   /// <summary>
   ///   text/plain (c)
   /// </summary>
   Text_Plain_c = 165,
   /// <summary>
   ///   text/plain (h)
   /// </summary>
   Text_Plain_h = 166,
   /// <summary>
   ///   text/plain (txt)
   /// </summary>
   Text_Plain_txt = 167,
   /// <summary>
   ///   text/richtext (rtx)
   /// </summary>
   Text_Richtext_rtx = 168,
   /// <summary>
   ///   text/scriptlet (sct)
   /// </summary>
   Text_Scriptlet_sct = 169,
   /// <summary>
   ///   text/tab-separated-values (tsv)
   /// </summary>
   Text_TabSeparatedValues_tsv = 170,
   /// <summary>
   ///   text/webviewhtml (htt)
   /// </summary>
   Text_Webviewhtml_htt = 171,
   /// <summary>
   ///   text/x-component (htc)
   /// </summary>
   Text_XComponent_htc = 172,
   /// <summary>
   ///   text/x-setext (etx)
   /// </summary>
   Text_XSetext_etx = 173,
   /// <summary>
   ///   text/x-vcard (vcf)
   /// </summary>
   Text_XVcard_vcf = 174,
   /// <summary>
   ///   video/mpeg (mp2)
   /// </summary>
   Video_Mpeg_mp2 = 175,
   /// <summary>
   ///   video/mpeg (mpa)
   /// </summary>
   Video_Mpeg_mpa = 176,
   /// <summary>
   ///   video/mpeg (mpe)
   /// </summary>
   Video_Mpeg_mpe = 177,
   /// <summary>
   ///   video/mpeg (mpeg)
   /// </summary>
   Video_Mpeg_mpeg = 178,
   /// <summary>
   ///   video/mpeg (mpg)
   /// </summary>
   Video_Mpeg_mpg = 179,
   /// <summary>
   ///   video/mpeg (mpv2)
   /// </summary>
   Video_Mpeg_mpv2 = 180,
   /// <summary>
   ///   video/quicktime (mov)
   /// </summary>
   Video_Quicktime_mov = 181,
   /// <summary>
   ///   video/quicktime (qt)
   /// </summary>
   Video_Quicktime_qt = 182,
   /// <summary>
   ///   video/x-la-asf (lsf)
   /// </summary>
   Video_XLaAsf_lsf = 183,
   /// <summary>
   ///   video/x-la-asf (lsx)
   /// </summary>
   Video_XLaAsf_lsx = 184,
   /// <summary>
   ///   video/x-ms-asf (asf)
   /// </summary>
   Video_XMsAsf_asf = 185,
   /// <summary>
   ///   video/x-ms-asf (asr)
   /// </summary>
   Video_XMsAsf_asr = 186,
   /// <summary>
   ///   video/x-ms-asf (asx)
   /// </summary>
   Video_XMsAsf_asx = 187,
   /// <summary>
   ///   video/x-msvideo (avi)
   /// </summary>
   Video_XMsvideo_avi = 188,
   /// <summary>
   ///   video/x-sgi-movie (movie)
   /// </summary>
   Video_XSgiMovie_movie = 189,
   /// <summary>
   ///   x-world/x-vrml (flr)
   /// </summary>
   XWorld_XVrml_flr = 190,
   /// <summary>
   ///   x-world/x-vrml (vrml)
   /// </summary>
   XWorld_XVrml_vrml = 191,
   /// <summary>
   ///   x-world/x-vrml (wrl)
   /// </summary>
   XWorld_XVrml_wrl = 192,
   /// <summary>
   ///   x-world/x-vrml (wrz)
   /// </summary>
   XWorld_XVrml_wrz = 193,
   /// <summary>
   ///   x-world/x-vrml (xaf)
   /// </summary>
   XWorld_XVrml_xaf = 194,
   /// <summary>
   ///   x-world/x-vrml (xof)
   /// </summary>
   XWorld_XVrml_xof = 195
}

export const MimeTypes: MimeType[] = [
   {
      code: MimeType_.Application_OctetStream,
      literal: 'Application_OctetStream',
      description: 'application/octet-stream',
      shortDescription: '',
      listPriority: 0,

      extension: '',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Envoy_evy,
      literal: 'Application_Envoy_evy',
      description: 'application/envoy',
      shortDescription: 'evy',
      listPriority: 0,

      extension: '.evy',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Fractals_fif,
      literal: 'Application_Fractals_fif',
      description: 'application/fractals',
      shortDescription: 'fif',
      listPriority: 0,

      extension: '.fif',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Futuresplash_spl,
      literal: 'Application_Futuresplash_spl',
      description: 'application/futuresplash',
      shortDescription: 'spl',
      listPriority: 0,

      extension: '.spl',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Hta_hta,
      literal: 'Application_Hta_hta',
      description: 'application/hta',
      shortDescription: 'hta',
      listPriority: 0,

      extension: '.hta',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_InternetPropStrm_acx,
      literal: 'Application_InternetPropStrm_acx',
      description: 'application/internet-property-stream',
      shortDescription: 'acx',
      listPriority: 0,

      extension: '.acx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_MacBinhex40_hqx,
      literal: 'Application_MacBinhex40_hqx',
      description: 'application/mac-binhex40',
      shortDescription: 'hqx',
      listPriority: 0,

      extension: '.hqx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_MsPowerpoint_pff,
      literal: 'Application_MsPowerpoint_pff',
      description: 'application/ms-powerpoint',
      shortDescription: 'pff',
      listPriority: 0,

      extension: '.pff',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Msword_doc,
      literal: 'Application_Msword_doc',
      description: 'application/msword',
      shortDescription: 'doc',
      listPriority: 0,

      extension: '.doc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Msword_dot,
      literal: 'Application_Msword_dot',
      description: 'application/msword',
      shortDescription: 'dot',
      listPriority: 0,

      extension: '.dot',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_OctetStream_bin,
      literal: 'Application_OctetStream_bin',
      description: 'application/octet-stream',
      shortDescription: 'bin',
      listPriority: 0,

      extension: '.bin',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_OctetStream_dms,
      literal: 'Application_OctetStream_dms',
      description: 'application/octet-stream',
      shortDescription: 'dms',
      listPriority: 0,

      extension: '.dms',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_OctetStream_exe,
      literal: 'Application_OctetStream_exe',
      description: 'application/octet-stream',
      shortDescription: 'exe',
      listPriority: 0,

      extension: '.exe',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_OctetStream_lha,
      literal: 'Application_OctetStream_lha',
      description: 'application/octet-stream',
      shortDescription: 'lha',
      listPriority: 0,

      extension: '.lha',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_OctetStream_lzh,
      literal: 'Application_OctetStream_lzh',
      description: 'application/octet-stream',
      shortDescription: 'lzh',
      listPriority: 0,

      extension: '.lzh',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Oda_oda,
      literal: 'Application_Oda_oda',
      description: 'application/oda',
      shortDescription: 'oda',
      listPriority: 0,

      extension: '.oda',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Olescript_axs,
      literal: 'Application_Olescript_axs',
      description: 'application/olescript',
      shortDescription: 'axs',
      listPriority: 0,

      extension: '.axs',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Pdf_pdf,
      literal: 'Application_Pdf_pdf',
      description: 'application/pdf',
      shortDescription: 'pdf',
      listPriority: 0,

      extension: '.pdf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_PicsRules_prf,
      literal: 'Application_PicsRules_prf',
      description: 'application/pics-rules',
      shortDescription: 'prf',
      listPriority: 0,

      extension: '.prf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Pkcs10_p10,
      literal: 'Application_Pkcs10_p10',
      description: 'application/pkcs10',
      shortDescription: 'p10',
      listPriority: 0,

      extension: '.p10',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_PkixCrl_crl,
      literal: 'Application_PkixCrl_crl',
      description: 'application/pkix-crl',
      shortDescription: 'crl',
      listPriority: 0,

      extension: '.crl',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Postscript_ai,
      literal: 'Application_Postscript_ai',
      description: 'application/postscript',
      shortDescription: 'ai',
      listPriority: 0,

      extension: '.ai',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Postscript_ps,
      literal: 'Application_Postscript_ps',
      description: 'application/postscript',
      shortDescription: 'ps',
      listPriority: 0,

      extension: '.ps',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Rtf_rtf,
      literal: 'Application_Rtf_rtf',
      description: 'application/rtf',
      shortDescription: 'rtf',
      listPriority: 0,

      extension: '.rtf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_SetPmtInit_setpay,
      literal: 'Application_SetPmtInit_setpay',
      description: 'application/set-payment-initiation',
      shortDescription: 'setpay',
      listPriority: 0,

      extension: '.setpay',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_SetRegInit_setreg,
      literal: 'Application_SetRegInit_setreg',
      description: 'application/set-registration-initiation',
      shortDescription: 'setreg',
      listPriority: 0,

      extension: '.setreg',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_csv,
      literal: 'Application_VndMsExcel_csv',
      description: 'application/vnd.ms-excel',
      shortDescription: 'csv',
      listPriority: 0,

      extension: '.csv',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xla,
      literal: 'Application_VndMsExcel_xla',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xla',
      listPriority: 0,

      extension: '.xla',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xlc,
      literal: 'Application_VndMsExcel_xlc',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xlc',
      listPriority: 0,

      extension: '.xlc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xlm,
      literal: 'Application_VndMsExcel_xlm',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xlm',
      listPriority: 0,

      extension: '.xlm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xls,
      literal: 'Application_VndMsExcel_xls',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xls',
      listPriority: 0,

      extension: '.xls',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xlt,
      literal: 'Application_VndMsExcel_xlt',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xlt',
      listPriority: 0,

      extension: '.xlt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsExcel_xlw,
      literal: 'Application_VndMsExcel_xlw',
      description: 'application/vnd.ms-excel',
      shortDescription: 'xlw',
      listPriority: 0,

      extension: '.xlw',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPkiCertStor_sst,
      literal: 'Application_VndMsPkiCertStor_sst',
      description: 'application/vnd.ms-pkicertstore',
      shortDescription: 'sst',
      listPriority: 0,

      extension: '.sst',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPkiSecCat_cat,
      literal: 'Application_VndMsPkiSecCat_cat',
      description: 'application/vnd.ms-pkiseccat',
      shortDescription: 'cat',
      listPriority: 0,

      extension: '.cat',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPkiStl_stl,
      literal: 'Application_VndMsPkiStl_stl',
      description: 'application/vnd.ms-pkistl',
      shortDescription: 'stl',
      listPriority: 0,

      extension: '.stl',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPowerpoint_pot,
      literal: 'Application_VndMsPowerpoint_pot',
      description: 'application/vnd.ms-powerpoint',
      shortDescription: 'pot',
      listPriority: 0,

      extension: '.pot',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPowerpoint_pps,
      literal: 'Application_VndMsPowerpoint_pps',
      description: 'application/vnd.ms-powerpoint',
      shortDescription: 'pps',
      listPriority: 0,

      extension: '.pps',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsPowerpoint_ppt,
      literal: 'Application_VndMsPowerpoint_ppt',
      description: 'application/vnd.ms-powerpoint',
      shortDescription: 'ppt',
      listPriority: 0,

      extension: '.ppt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsProject_mpp,
      literal: 'Application_VndMsProject_mpp',
      description: 'application/vnd.ms-project',
      shortDescription: 'mpp',
      listPriority: 0,

      extension: '.mpp',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsWorks_wcm,
      literal: 'Application_VndMsWorks_wcm',
      description: 'application/vnd.ms-works',
      shortDescription: 'wcm',
      listPriority: 0,

      extension: '.wcm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsWorks_wdb,
      literal: 'Application_VndMsWorks_wdb',
      description: 'application/vnd.ms-works',
      shortDescription: 'wdb',
      listPriority: 0,

      extension: '.wdb',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsWorks_wks,
      literal: 'Application_VndMsWorks_wks',
      description: 'application/vnd.ms-works',
      shortDescription: 'wks',
      listPriority: 0,

      extension: '.wks',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndMsWorks_wps,
      literal: 'Application_VndMsWorks_wps',
      description: 'application/vnd.ms-works',
      shortDescription: 'wps',
      listPriority: 0,

      extension: '.wps',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndXmlOffice_pptx,
      literal: 'Application_VndXmlOffice_pptx',
      description: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      shortDescription: 'pptx',
      listPriority: 0,

      extension: '.pptx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndXmlOffice_xlsx,
      literal: 'Application_VndXmlOffice_xlsx',
      description: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      shortDescription: 'xlsx',
      listPriority: 0,

      extension: '.xlsx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndXmlOffice_xltx,
      literal: 'Application_VndXmlOffice_xltx',
      description: 'application/vnd.openxmlformats-officedocument.spreadsheetml.templat',
      shortDescription: 'xltx',
      listPriority: 0,

      extension: '.xltx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndXmlOffice_docx,
      literal: 'Application_VndXmlOffice_docx',
      description: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      shortDescription: 'docx',
      listPriority: 0,

      extension: '.docx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_VndXmlOffice_dotx,
      literal: 'Application_VndXmlOffice_dotx',
      description: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
      shortDescription: 'dotx',
      listPriority: 0,

      extension: '.dotx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Winhlp_hlp,
      literal: 'Application_Winhlp_hlp',
      description: 'application/winhlp',
      shortDescription: 'hlp',
      listPriority: 0,

      extension: '.hlp',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XBcpio_bcpio,
      literal: 'Application_XBcpio_bcpio',
      description: 'application/x-bcpio',
      shortDescription: 'bcpio',
      listPriority: 0,

      extension: '.bcpio',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XCdf_cdf,
      literal: 'Application_XCdf_cdf',
      description: 'application/x-cdf',
      shortDescription: 'cdf',
      listPriority: 0,

      extension: '.cdf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XCompress_z,
      literal: 'Application_XCompress_z',
      description: 'application/x-compress',
      shortDescription: 'z',
      listPriority: 0,

      extension: '.z',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XCompressed_tgz,
      literal: 'Application_XCompressed_tgz',
      description: 'application/x-compressed',
      shortDescription: 'tgz',
      listPriority: 0,

      extension: '.tgz',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XCpio_cpio,
      literal: 'Application_XCpio_cpio',
      description: 'application/x-cpio',
      shortDescription: 'cpio',
      listPriority: 0,

      extension: '.cpio',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XCsh_csh,
      literal: 'Application_XCsh_csh',
      description: 'application/x-csh',
      shortDescription: 'csh',
      listPriority: 0,

      extension: '.csh',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XDirector_dcr,
      literal: 'Application_XDirector_dcr',
      description: 'application/x-director',
      shortDescription: 'dcr',
      listPriority: 0,

      extension: '.dcr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XDirector_dir,
      literal: 'Application_XDirector_dir',
      description: 'application/x-director',
      shortDescription: 'dir',
      listPriority: 0,

      extension: '.dir',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XDirector_dxr,
      literal: 'Application_XDirector_dxr',
      description: 'application/x-director',
      shortDescription: 'dxr',
      listPriority: 0,

      extension: '.dxr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XDvi_dvi,
      literal: 'Application_XDvi_dvi',
      description: 'application/x-dvi',
      shortDescription: 'dvi',
      listPriority: 0,

      extension: '.dvi',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XGtar_gtar,
      literal: 'Application_XGtar_gtar',
      description: 'application/x-gtar',
      shortDescription: 'gtar',
      listPriority: 0,

      extension: '.gtar',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XGzip_gz,
      literal: 'Application_XGzip_gz',
      description: 'application/x-gzip',
      shortDescription: 'gz',
      listPriority: 0,

      extension: '.gz',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XHdf_hdf,
      literal: 'Application_XHdf_hdf',
      description: 'application/x-hdf',
      shortDescription: 'hdf',
      listPriority: 0,

      extension: '.hdf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XInternetSignup_ins,
      literal: 'Application_XInternetSignup_ins',
      description: 'application/x-internet-signup',
      shortDescription: 'ins',
      listPriority: 0,

      extension: '.ins',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XInternetSignup_isp,
      literal: 'Application_XInternetSignup_isp',
      description: 'application/x-internet-signup',
      shortDescription: 'isp',
      listPriority: 0,

      extension: '.isp',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XIphone_iii,
      literal: 'Application_XIphone_iii',
      description: 'application/x-iphone',
      shortDescription: 'iii',
      listPriority: 0,

      extension: '.iii',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XJavascript_js,
      literal: 'Application_XJavascript_js',
      description: 'application/x-javascript',
      shortDescription: 'js',
      listPriority: 0,

      extension: '.js',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XLatex_latex,
      literal: 'Application_XLatex_latex',
      description: 'application/x-latex',
      shortDescription: 'latex',
      listPriority: 0,

      extension: '.latex',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMplayer2_hold,
      literal: 'Application_XMplayer2_hold',
      description: 'application/x-mplayer2',
      shortDescription: 'hold',
      listPriority: 0,

      extension: '.hold',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsaccess_mdb,
      literal: 'Application_XMsaccess_mdb',
      description: 'application/x-msaccess',
      shortDescription: 'mdb',
      listPriority: 0,

      extension: '.mdb',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMscardfile_crd,
      literal: 'Application_XMscardfile_crd',
      description: 'application/x-mscardfile',
      shortDescription: 'crd',
      listPriority: 0,

      extension: '.crd',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsclip_clp,
      literal: 'Application_XMsclip_clp',
      description: 'application/x-msclip',
      shortDescription: 'clp',
      listPriority: 0,

      extension: '.clp',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsdownload_dll,
      literal: 'Application_XMsdownload_dll',
      description: 'application/x-msdownload',
      shortDescription: 'dll',
      listPriority: 0,

      extension: '.dll',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsmediaview_m13,
      literal: 'Application_XMsmediaview_m13',
      description: 'application/x-msmediaview',
      shortDescription: 'm13',
      listPriority: 0,

      extension: '.m13',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsmediaview_m14,
      literal: 'Application_XMsmediaview_m14',
      description: 'application/x-msmediaview',
      shortDescription: 'm14',
      listPriority: 0,

      extension: '.m14',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsmediaview_mvb,
      literal: 'Application_XMsmediaview_mvb',
      description: 'application/x-msmediaview',
      shortDescription: 'mvb',
      listPriority: 0,

      extension: '.mvb',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsmetafile_wmf,
      literal: 'Application_XMsmetafile_wmf',
      description: 'application/x-msmetafile',
      shortDescription: 'wmf',
      listPriority: 0,

      extension: '.wmf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsmoney_mny,
      literal: 'Application_XMsmoney_mny',
      description: 'application/x-msmoney',
      shortDescription: 'mny',
      listPriority: 0,

      extension: '.mny',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMspublisher_pub,
      literal: 'Application_XMspublisher_pub',
      description: 'application/x-mspublisher',
      shortDescription: 'pub',
      listPriority: 0,

      extension: '.pub',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsschedule_scd,
      literal: 'Application_XMsschedule_scd',
      description: 'application/x-msschedule',
      shortDescription: 'scd',
      listPriority: 0,

      extension: '.scd',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMsterminal_trm,
      literal: 'Application_XMsterminal_trm',
      description: 'application/x-msterminal',
      shortDescription: 'trm',
      listPriority: 0,

      extension: '.trm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XMswrite_wri,
      literal: 'Application_XMswrite_wri',
      description: 'application/x-mswrite',
      shortDescription: 'wri',
      listPriority: 0,

      extension: '.wri',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPerfmon_pma,
      literal: 'Application_XPerfmon_pma',
      description: 'application/x-perfmon',
      shortDescription: 'pma',
      listPriority: 0,

      extension: '.pma',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPerfmon_pmc,
      literal: 'Application_XPerfmon_pmc',
      description: 'application/x-perfmon',
      shortDescription: 'pmc',
      listPriority: 0,

      extension: '.pmc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPerfmon_pml,
      literal: 'Application_XPerfmon_pml',
      description: 'application/x-perfmon',
      shortDescription: 'pml',
      listPriority: 0,

      extension: '.pml',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPerfmon_pmr,
      literal: 'Application_XPerfmon_pmr',
      description: 'application/x-perfmon',
      shortDescription: 'pmr',
      listPriority: 0,

      extension: '.pmr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPerfmon_pmw,
      literal: 'Application_XPerfmon_pmw',
      description: 'application/x-perfmon',
      shortDescription: 'pmw',
      listPriority: 0,

      extension: '.pmw',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs12_p12,
      literal: 'Application_XPkcs12_p12',
      description: 'application/x-pkcs12',
      shortDescription: 'p12',
      listPriority: 0,

      extension: '.p12',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs12_pfx,
      literal: 'Application_XPkcs12_pfx',
      description: 'application/x-pkcs12',
      shortDescription: 'pfx',
      listPriority: 0,

      extension: '.pfx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7Certs_p7b,
      literal: 'Application_XPkcs7Certs_p7b',
      description: 'application/x-pkcs7-certificates',
      shortDescription: 'p7b',
      listPriority: 0,

      extension: '.p7b',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7Certs_spc,
      literal: 'Application_XPkcs7Certs_spc',
      description: 'application/x-pkcs7-certificates',
      shortDescription: 'spc',
      listPriority: 0,

      extension: '.spc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7CertReqRes_p7r,
      literal: 'Application_XPkcs7CertReqRes_p7r',
      description: 'application/x-pkcs7-certreqresp',
      shortDescription: 'p7r',
      listPriority: 0,

      extension: '.p7r',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7Mime_p7c,
      literal: 'Application_XPkcs7Mime_p7c',
      description: 'application/x-pkcs7-mime',
      shortDescription: 'p7c',
      listPriority: 0,

      extension: '.p7c',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7Mime_p7m,
      literal: 'Application_XPkcs7Mime_p7m',
      description: 'application/x-pkcs7-mime',
      shortDescription: 'p7m',
      listPriority: 0,

      extension: '.p7m',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XPkcs7Signature_p7s,
      literal: 'Application_XPkcs7Signature_p7s',
      description: 'application/x-pkcs7-signature',
      shortDescription: 'p7s',
      listPriority: 0,

      extension: '.p7s',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XSh_sh,
      literal: 'Application_XSh_sh',
      description: 'application/x-sh',
      shortDescription: 'sh',
      listPriority: 0,

      extension: '.sh',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XShar_shar,
      literal: 'Application_XShar_shar',
      description: 'application/x-shar',
      shortDescription: 'shar',
      listPriority: 0,

      extension: '.shar',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XStuffit_sit,
      literal: 'Application_XStuffit_sit',
      description: 'application/x-stuffit',
      shortDescription: 'sit',
      listPriority: 0,

      extension: '.sit',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XSv4cpio_sv4cpio,
      literal: 'Application_XSv4cpio_sv4cpio',
      description: 'application/x-sv4cpio',
      shortDescription: 'sv4cpio',
      listPriority: 0,

      extension: '.sv4cpio',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XSv4crc_sv4crc,
      literal: 'Application_XSv4crc_sv4crc',
      description: 'application/x-sv4crc',
      shortDescription: 'sv4crc',
      listPriority: 0,

      extension: '.sv4crc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTar_tar,
      literal: 'Application_XTar_tar',
      description: 'application/x-tar',
      shortDescription: 'tar',
      listPriority: 0,

      extension: '.tar',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTcl_tcl,
      literal: 'Application_XTcl_tcl',
      description: 'application/x-tcl',
      shortDescription: 'tcl',
      listPriority: 0,

      extension: '.tcl',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTex_tex,
      literal: 'Application_XTex_tex',
      description: 'application/x-tex',
      shortDescription: 'tex',
      listPriority: 0,

      extension: '.tex',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTexinfo_texi,
      literal: 'Application_XTexinfo_texi',
      description: 'application/x-texinfo',
      shortDescription: 'texi',
      listPriority: 0,

      extension: '.texi',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTexinfo_texinfo,
      literal: 'Application_XTexinfo_texinfo',
      description: 'application/x-texinfo',
      shortDescription: 'texinfo',
      listPriority: 0,

      extension: '.texinfo',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroff_roff,
      literal: 'Application_XTroff_roff',
      description: 'application/x-troff',
      shortDescription: 'roff',
      listPriority: 0,

      extension: '.roff',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroff_t,
      literal: 'Application_XTroff_t',
      description: 'application/x-troff',
      shortDescription: 't',
      listPriority: 0,

      extension: '.t',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroff_tr,
      literal: 'Application_XTroff_tr',
      description: 'application/x-troff',
      shortDescription: 'tr',
      listPriority: 0,

      extension: '.tr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroffMan_man,
      literal: 'Application_XTroffMan_man',
      description: 'application/x-troff-man',
      shortDescription: 'man',
      listPriority: 0,

      extension: '.man',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroffMe_me,
      literal: 'Application_XTroffMe_me',
      description: 'application/x-troff-me',
      shortDescription: 'me',
      listPriority: 0,

      extension: '.me',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XTroffMs_ms,
      literal: 'Application_XTroffMs_ms',
      description: 'application/x-troff-ms',
      shortDescription: 'ms',
      listPriority: 0,

      extension: '.ms',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XUstar_ustar,
      literal: 'Application_XUstar_ustar',
      description: 'application/x-ustar',
      shortDescription: 'ustar',
      listPriority: 0,

      extension: '.ustar',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XWaisSource_src,
      literal: 'Application_XWaisSource_src',
      description: 'application/x-wais-source',
      shortDescription: 'src',
      listPriority: 0,

      extension: '.src',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XX509CaCert_cer,
      literal: 'Application_XX509CaCert_cer',
      description: 'application/x-x509-ca-cert',
      shortDescription: 'cer',
      listPriority: 0,

      extension: '.cer',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XX509CaCert_crt,
      literal: 'Application_XX509CaCert_crt',
      description: 'application/x-x509-ca-cert',
      shortDescription: 'crt',
      listPriority: 0,

      extension: '.crt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_XX509CaCert_der,
      literal: 'Application_XX509CaCert_der',
      description: 'application/x-x509-ca-cert',
      shortDescription: 'der',
      listPriority: 0,

      extension: '.der',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_YndMsPkipko_pko,
      literal: 'Application_YndMsPkipko_pko',
      description: 'application/ynd.ms-pkipko',
      shortDescription: 'pko',
      listPriority: 0,

      extension: '.pko',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Application_Zip_zip,
      literal: 'Application_Zip_zip',
      description: 'application/zip',
      shortDescription: 'zip',
      listPriority: 0,

      extension: '.zip',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_Basic_au,
      literal: 'Audio_Basic_au',
      description: 'audio/basic',
      shortDescription: 'au',
      listPriority: 0,

      extension: '.au',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_Basic_snd,
      literal: 'Audio_Basic_snd',
      description: 'audio/basic',
      shortDescription: 'snd',
      listPriority: 0,

      extension: '.snd',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_Mid_mid,
      literal: 'Audio_Mid_mid',
      description: 'audio/mid',
      shortDescription: 'mid',
      listPriority: 0,

      extension: '.mid',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_Mid_rmi,
      literal: 'Audio_Mid_rmi',
      description: 'audio/mid',
      shortDescription: 'rmi',
      listPriority: 0,

      extension: '.rmi',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_Mpeg3_mp3,
      literal: 'Audio_Mpeg3_mp3',
      description: 'audio/mpeg3',
      shortDescription: 'mp3',
      listPriority: 0,

      extension: '.mp3',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XAiff_aif,
      literal: 'Audio_XAiff_aif',
      description: 'audio/x-aiff',
      shortDescription: 'aif',
      listPriority: 0,

      extension: '.aif',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XAiff_aifc,
      literal: 'Audio_XAiff_aifc',
      description: 'audio/x-aiff',
      shortDescription: 'aifc',
      listPriority: 0,

      extension: '.aifc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XAiff_aiff,
      literal: 'Audio_XAiff_aiff',
      description: 'audio/x-aiff',
      shortDescription: 'aiff',
      listPriority: 0,

      extension: '.aiff',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XMpegurl_m3u,
      literal: 'Audio_XMpegurl_m3u',
      description: 'audio/x-mpegurl',
      shortDescription: 'm3u',
      listPriority: 0,

      extension: '.m3u',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XPnRealaudio_ra,
      literal: 'Audio_XPnRealaudio_ra',
      description: 'audio/x-pn-realaudio',
      shortDescription: 'ra',
      listPriority: 0,

      extension: '.ra',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XPnRealaudio_ram,
      literal: 'Audio_XPnRealaudio_ram',
      description: 'audio/x-pn-realaudio',
      shortDescription: 'ram',
      listPriority: 0,

      extension: '.ram',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Audio_XWav_wav,
      literal: 'Audio_XWav_wav',
      description: 'audio/x-wav',
      shortDescription: 'wav',
      listPriority: 0,

      extension: '.wav',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_CisCod_cod,
      literal: 'Image_CisCod_cod',
      description: 'image/cis-cod',
      shortDescription: 'cod',
      listPriority: 0,

      extension: '.cod',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Gif_gif,
      literal: 'Image_Gif_gif',
      description: 'image/gif',
      shortDescription: 'gif',
      listPriority: 0,

      extension: '.gif',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Ief_ief,
      literal: 'Image_Ief_ief',
      description: 'image/ief',
      shortDescription: 'ief',
      listPriority: 0,

      extension: '.ief',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Jpeg_jpe,
      literal: 'Image_Jpeg_jpe',
      description: 'image/JPEG',
      shortDescription: 'jpe',
      listPriority: 0,

      extension: '.jpe',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Jpeg_jpeg,
      literal: 'Image_Jpeg_jpeg',
      description: 'image/JPEG',
      shortDescription: 'jpeg',
      listPriority: 0,

      extension: '.jpeg',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Jpeg_jpg,
      literal: 'Image_Jpeg_jpg',
      description: 'image/JPEG',
      shortDescription: 'jpg',
      listPriority: 0,

      extension: '.jpg',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Pipeg_jfif,
      literal: 'Image_Pipeg_jfif',
      description: 'image/pipeg',
      shortDescription: 'jfif',
      listPriority: 0,

      extension: '.jfif',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Tiff_tif,
      literal: 'Image_Tiff_tif',
      description: 'image/tiff',
      shortDescription: 'tif',
      listPriority: 0,

      extension: '.tif',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_Tiff_tiff,
      literal: 'Image_Tiff_tiff',
      description: 'image/tiff',
      shortDescription: 'tiff',
      listPriority: 0,

      extension: '.tiff',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XCmuRaster_ras,
      literal: 'Image_XCmuRaster_ras',
      description: 'image/x-cmu-raster',
      shortDescription: 'ras',
      listPriority: 0,

      extension: '.ras',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XCmx_cmx,
      literal: 'Image_XCmx_cmx',
      description: 'image/x-cmx',
      shortDescription: 'cmx',
      listPriority: 0,

      extension: '.cmx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XEps_eps,
      literal: 'Image_XEps_eps',
      description: 'image/x-eps',
      shortDescription: 'eps',
      listPriority: 0,

      extension: '.eps',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XIcon_ico,
      literal: 'Image_XIcon_ico',
      description: 'image/x-icon',
      shortDescription: 'ico',
      listPriority: 0,

      extension: '.ico',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XMsBmp_bmp,
      literal: 'Image_XMsBmp_bmp',
      description: 'image/x-ms-bmp',
      shortDescription: 'bmp',
      listPriority: 0,

      extension: '.bmp',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPng_png,
      literal: 'Image_XPng_png',
      description: 'image/x-png',
      shortDescription: 'png',
      listPriority: 0,

      extension: '.png',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPortableAnymap_pnm,
      literal: 'Image_XPortableAnymap_pnm',
      description: 'image/x-portable-anymap',
      shortDescription: 'pnm',
      listPriority: 0,

      extension: '.pnm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPortableBitmap_pbm,
      literal: 'Image_XPortableBitmap_pbm',
      description: 'image/x-portable-bitmap',
      shortDescription: 'pbm',
      listPriority: 0,

      extension: '.pbm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPortableGraymap_pgm,
      literal: 'Image_XPortableGraymap_pgm',
      description: 'image/x-portable-graymap',
      shortDescription: 'pgm',
      listPriority: 0,

      extension: '.pgm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPortablePixmap_ppm,
      literal: 'Image_XPortablePixmap_ppm',
      description: 'image/x-portable-pixmap',
      shortDescription: 'ppm',
      listPriority: 0,

      extension: '.ppm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XPsd_psd,
      literal: 'Image_XPsd_psd',
      description: 'image/x-psd',
      shortDescription: 'psd',
      listPriority: 0,

      extension: '.psd',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XRgb_rgb,
      literal: 'Image_XRgb_rgb',
      description: 'image/x-rgb',
      shortDescription: 'rgb',
      listPriority: 0,

      extension: '.rgb',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XXbitmap_xbm,
      literal: 'Image_XXbitmap_xbm',
      description: 'image/x-xbitmap',
      shortDescription: 'xbm',
      listPriority: 0,

      extension: '.xbm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XXpixmap_xpm,
      literal: 'Image_XXpixmap_xpm',
      description: 'image/x-xpixmap',
      shortDescription: 'xpm',
      listPriority: 0,

      extension: '.xpm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Image_XXwindowdump_xwd,
      literal: 'Image_XXwindowdump_xwd',
      description: 'image/x-xwindowdump',
      shortDescription: 'xwd',
      listPriority: 0,

      extension: '.xwd',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Message_Rfc822_mht,
      literal: 'Message_Rfc822_mht',
      description: 'message/rfc822',
      shortDescription: 'mht',
      listPriority: 0,

      extension: '.mht',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Message_Rfc822_mhtml,
      literal: 'Message_Rfc822_mhtml',
      description: 'message/rfc822',
      shortDescription: 'mhtml',
      listPriority: 0,

      extension: '.mhtml',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Message_Rfc822_nws,
      literal: 'Message_Rfc822_nws',
      description: 'message/rfc822',
      shortDescription: 'nws',
      listPriority: 0,

      extension: '.nws',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Css_css,
      literal: 'Text_Css_css',
      description: 'text/css',
      shortDescription: 'css',
      listPriority: 0,

      extension: '.css',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_H323_h323,
      literal: 'Text_H323_h323',
      description: 'text/h323',
      shortDescription: 'h323',
      listPriority: 0,

      extension: '.323',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Html_htm,
      literal: 'Text_Html_htm',
      description: 'text/HTML',
      shortDescription: 'htm',
      listPriority: 0,

      extension: '.htm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Html_html,
      literal: 'Text_Html_html',
      description: 'text/HTML',
      shortDescription: 'html',
      listPriority: 0,

      extension: '.html',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Html_stm,
      literal: 'Text_Html_stm',
      description: 'text/html',
      shortDescription: 'stm',
      listPriority: 0,

      extension: '.stm',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Iuls_uls,
      literal: 'Text_Iuls_uls',
      description: 'text/iuls',
      shortDescription: 'uls',
      listPriority: 0,

      extension: '.uls',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Plain_bas,
      literal: 'Text_Plain_bas',
      description: 'text/plain',
      shortDescription: 'bas',
      listPriority: 0,

      extension: '.bas',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Plain_c,
      literal: 'Text_Plain_c',
      description: 'text/plain',
      shortDescription: 'c',
      listPriority: 0,

      extension: '.c',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Plain_h,
      literal: 'Text_Plain_h',
      description: 'text/plain',
      shortDescription: 'h',
      listPriority: 0,

      extension: '.h',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Plain_txt,
      literal: 'Text_Plain_txt',
      description: 'text/plain',
      shortDescription: 'txt',
      listPriority: 0,

      extension: '.txt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Richtext_rtx,
      literal: 'Text_Richtext_rtx',
      description: 'text/richtext',
      shortDescription: 'rtx',
      listPriority: 0,

      extension: '.rtx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Scriptlet_sct,
      literal: 'Text_Scriptlet_sct',
      description: 'text/scriptlet',
      shortDescription: 'sct',
      listPriority: 0,

      extension: '.sct',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_TabSeparatedValues_tsv,
      literal: 'Text_TabSeparatedValues_tsv',
      description: 'text/tab-separated-values',
      shortDescription: 'tsv',
      listPriority: 0,

      extension: '.tsv',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_Webviewhtml_htt,
      literal: 'Text_Webviewhtml_htt',
      description: 'text/webviewhtml',
      shortDescription: 'htt',
      listPriority: 0,

      extension: '.htt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_XComponent_htc,
      literal: 'Text_XComponent_htc',
      description: 'text/x-component',
      shortDescription: 'htc',
      listPriority: 0,

      extension: '.htc',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_XSetext_etx,
      literal: 'Text_XSetext_etx',
      description: 'text/x-setext',
      shortDescription: 'etx',
      listPriority: 0,

      extension: '.etx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Text_XVcard_vcf,
      literal: 'Text_XVcard_vcf',
      description: 'text/x-vcard',
      shortDescription: 'vcf',
      listPriority: 0,

      extension: '.vcf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mp2,
      literal: 'Video_Mpeg_mp2',
      description: 'video/mpeg',
      shortDescription: 'mp2',
      listPriority: 0,

      extension: '.mp2',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mpa,
      literal: 'Video_Mpeg_mpa',
      description: 'video/mpeg',
      shortDescription: 'mpa',
      listPriority: 0,

      extension: '.mpa',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mpe,
      literal: 'Video_Mpeg_mpe',
      description: 'video/mpeg',
      shortDescription: 'mpe',
      listPriority: 0,

      extension: '.mpe',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mpeg,
      literal: 'Video_Mpeg_mpeg',
      description: 'video/mpeg',
      shortDescription: 'mpeg',
      listPriority: 0,

      extension: '.mpeg',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mpg,
      literal: 'Video_Mpeg_mpg',
      description: 'video/mpeg',
      shortDescription: 'mpg',
      listPriority: 0,

      extension: '.mpg',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Mpeg_mpv2,
      literal: 'Video_Mpeg_mpv2',
      description: 'video/mpeg',
      shortDescription: 'mpv2',
      listPriority: 0,

      extension: '.mpv2',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Quicktime_mov,
      literal: 'Video_Quicktime_mov',
      description: 'video/quicktime',
      shortDescription: 'mov',
      listPriority: 0,

      extension: '.mov',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_Quicktime_qt,
      literal: 'Video_Quicktime_qt',
      description: 'video/quicktime',
      shortDescription: 'qt',
      listPriority: 0,

      extension: '.qt',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XLaAsf_lsf,
      literal: 'Video_XLaAsf_lsf',
      description: 'video/x-la-asf',
      shortDescription: 'lsf',
      listPriority: 0,

      extension: '.lsf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XLaAsf_lsx,
      literal: 'Video_XLaAsf_lsx',
      description: 'video/x-la-asf',
      shortDescription: 'lsx',
      listPriority: 0,

      extension: '.lsx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XMsAsf_asf,
      literal: 'Video_XMsAsf_asf',
      description: 'video/x-ms-asf',
      shortDescription: 'asf',
      listPriority: 0,

      extension: '.asf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XMsAsf_asr,
      literal: 'Video_XMsAsf_asr',
      description: 'video/x-ms-asf',
      shortDescription: 'asr',
      listPriority: 0,

      extension: '.asr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XMsAsf_asx,
      literal: 'Video_XMsAsf_asx',
      description: 'video/x-ms-asf',
      shortDescription: 'asx',
      listPriority: 0,

      extension: '.asx',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XMsvideo_avi,
      literal: 'Video_XMsvideo_avi',
      description: 'video/x-msvideo',
      shortDescription: 'avi',
      listPriority: 0,

      extension: '.avi',

      typeName: "MimeType"
   },
   {
      code: MimeType_.Video_XSgiMovie_movie,
      literal: 'Video_XSgiMovie_movie',
      description: 'video/x-sgi-movie',
      shortDescription: 'movie',
      listPriority: 0,

      extension: '.movie',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_flr,
      literal: 'XWorld_XVrml_flr',
      description: 'x-world/x-vrml',
      shortDescription: 'flr',
      listPriority: 0,

      extension: '.flr',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_vrml,
      literal: 'XWorld_XVrml_vrml',
      description: 'x-world/x-vrml',
      shortDescription: 'vrml',
      listPriority: 0,

      extension: '.vrml',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_wrl,
      literal: 'XWorld_XVrml_wrl',
      description: 'x-world/x-vrml',
      shortDescription: 'wrl',
      listPriority: 0,

      extension: '.wrl',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_wrz,
      literal: 'XWorld_XVrml_wrz',
      description: 'x-world/x-vrml',
      shortDescription: 'wrz',
      listPriority: 0,

      extension: '.wrz',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_xaf,
      literal: 'XWorld_XVrml_xaf',
      description: 'x-world/x-vrml',
      shortDescription: 'xaf',
      listPriority: 0,

      extension: '.xaf',

      typeName: "MimeType"
   },
   {
      code: MimeType_.XWorld_XVrml_xof,
      literal: 'XWorld_XVrml_xof',
      description: 'x-world/x-vrml',
      shortDescription: 'xof',
      listPriority: 0,

      extension: '.xof',

      typeName: "MimeType"
   }
]

export class MimeType implements IDomainModel {
   code: MimeType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   extension: string

   typeName: string

   static toDomainModel(code: MimeType_): MimeType {
      return MimeTypes.find(d => d.code === code)
   }
}
